import { render } from "./Financeiro.vue?vue&type=template&id=87731ebc&scoped=true"
import script from "./Financeiro.vue?vue&type=script&lang=js"
export * from "./Financeiro.vue?vue&type=script&lang=js"

import "./Financeiro.vue?vue&type=style&index=0&id=87731ebc&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87731ebc"]])

export default __exports__